module.exports = __webpack_public_path__ + "static/media/editiconblack.21fb3e93.svg";